module.exports = __webpack_public_path__ + "assets/36ec01f6199c165c5473111fe29fa1cf.svg";